import React, { Component } from 'react';
import { Layout, Menu, Icon } from 'antd';

const { Footer } = Layout;

import styles from './FooterBarLess.less';
import { NavLink } from 'react-router-dom';

export default class FooterBarView extends Component {
  render() {

    return (
      <div className="footer_box">
        <Footer className='footer'>
          {/*云徙科技 版权所有 © {(new Date().getFullYear())}*/}
      </Footer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/widget/FooterBar/FooterBarView.js